import React from 'react';
import PropTypes from 'prop-types';

// Util
import preloadImages from '../../../../../utils/preloadImages';
import imagePopupStayActivePredicate from './popup/imagePopupStayActivePredicate';

// Components
import ImageSearchPopup from './popup/ImageSearchPopup';
import TooltipSource from '../../../../../components/tooltips/TooltipSource';
import ToolbarPopupTool from '../../ToolbarPopupTool';

// Constants
import { TooltipPositions } from '../../../../../components/tooltips/tooltipConstants';
import { TIMES } from '../../../../../../common/utils/timeUtil';

// Styles
import './ImageTool.scss';

class ImageTool extends React.Component {
    componentDidMount() {
        preloadImages([require('./popup/image-upload-form-illustration.png')]);
    }

    render() {
        const { tooltipEnabled } = this.props;

        return (
            <div className="ImagePopupTool">
                <TooltipSource
                    tooltipText="Click me"
                    position={TooltipPositions.RIGHT}
                    distance={5}
                    duration={TIMES.SECOND * 5}
                    enabled={tooltipEnabled}
                    fade
                    triggerOnDrag
                >
                    <ToolbarPopupTool
                        {...this.props}
                        name="Add image"
                        toolName="image"
                        stayActivePredicate={imagePopupStayActivePredicate}
                        PopupComponent={ImageSearchPopup}
                    />
                </TooltipSource>
            </div>
        );
    }
}

ImageTool.propTypes = {
    gridSize: PropTypes.number.isRequired,
    openImagePopup: PropTypes.func,
    selectedIcon: PropTypes.object,
    popupIsOpen: PropTypes.bool,
    selectedElements: PropTypes.object,
    selectedImage: PropTypes.string,
    firstElementId: PropTypes.string,
    tooltipEnabled: PropTypes.bool,
};

export default ImageTool;
